import React, { useState, useEffect } from "react";
import { Modal, Input, Table, message, Tag } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import { session } from "../../../../services/session";
import { config } from "../../../../config";

const get = async (url) => {
  const token = session.get();
  const headers = {};

  if (token) {
    headers[config.backendTokenKEY] = `Bearer ${token}`;
  }

  return await axios.get(url, { headers });
};

const TransportModal = ({ visible, data, onClose, refetch }) => {
  const [loading, setLoading] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [headerData, setHeaderData] = useState(null);
  const [isItemsModalVisible, setIsItemsModalVisible] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [itemsData, setItemsData] = useState([]);
  const [itemsLoading, setItemsLoading] = useState(false);

  useEffect(() => {
    if (visible && data?.U_TransportID) {
      fetchData();
    }
  }, [visible, data?.U_TransportID]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const url = `https://api.krupasnab.uz/api/Purchase/purchase-invoices-transit?docEntry=${data.U_TransportID}`;
      const { data: responseData } = await get(url);

      if (responseData && responseData.length > 0) {
        setModalData(responseData);
      }
    } catch (error) {
      console.log("Error:", error);
      message.error("Ma'lumotlarni yuklashda xatolik yuz berdi");
    } finally {
      setLoading(false);
    }
  };

  const fetchItemsData = async (docEntry) => {
    try {
      setItemsLoading(true);
      const url = `https://api.krupasnab.uz/api/Purchase/purchase-invoices-transit-items?docEntry=${docEntry}`;
      const { data: responseData } = await get(url);

      if (responseData) {
        setItemsData(responseData);
      }
    } catch (error) {
      console.log("Error:", error);
      message.error("Mahsulot ma'lumotlarini yuklashda xatolik yuz berdi");
    } finally {
      setItemsLoading(false);
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record);
    setIsItemsModalVisible(true);
    fetchItemsData(record.u_TransportItems);
  };

  if (!data) return null;

  const columns = [
    {
      title: "Transport turi",
      dataIndex: "u_TransportType",
      key: "u_TransportType",
      width: 150,
      render: (text) => text || "-",
    },
    {
      title: "Transport raqami",
      dataIndex: "u_TransportNumber",
      key: "u_TransportNumber",
      width: 150,
      render: (text) => text || "-",
    },
    {
      title: "Soni",
      dataIndex: "u_TransportItems",
      key: "u_TransportItems",
      width: 120,
      render: (text) => {
        return text ? new Intl.NumberFormat("fr-FR").format(text) : "-";
      },
    },
    {
      title: "Chiqish tasdiqlangan",
      dataIndex: "u_LeavingAllowed",
      key: "u_LeavingAllowed",
      width: 180,
      render: (text) => {
        return text === "Yes" ? (
          <Tag color="green">Ruxsat etilgan</Tag>
        ) : text === "No" ? (
          <Tag color="red">Ruxsat etilmagan</Tag>
        ) : (
          "-"
        );
      },
    },
    {
      title: "Yuk ko'chirildimi",
      dataIndex: "u_IsTransferMade",
      key: "u_IsTransferMade",
      width: 150,
      render: (text) => {
        return text === "Yes" ? (
          <Tag color="green">Ko'chirildi</Tag>
        ) : text === "No" ? (
          <Tag color="red">Ko'chirilmadi</Tag>
        ) : (
          "-"
        );
      },
    },
  ];

  const itemsColumns = [
    {
      title: "Maxsulot",
      dataIndex: "u_ItemName",
      key: "u_ItemName",
      width: 400,
    },
    {
      title: "Soni",
      dataIndex: "u_Quantity",
      key: "u_Quantity",
      width: 150,
      render: (text) => {
        return text
          ? new Intl.NumberFormat("fr-FR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(text)
          : "-";
      },
    },
    {
      title: "Qadoq o'lchov birligi",
      dataIndex: "u_UoM",
      key: "u_UoM",
      width: 150,
      render: (text) => text || "-",
    },
  ];

  return (
    <>
      <Modal
        title={
          <h1 className="font-nunito text-xl font-extrabold text-[#000000]">
            Hujjat № {data.docNum}
          </h1>
        }
        open={visible}
        onCancel={onClose}
        footer={null}
        closeIcon={<CloseOutlined />}
        width="50%"
        bodyStyle={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <div className="w-full px-4 sm:px-5">
          <div className="w-full">
            <div className="mt-5 grid grid-cols-2 gap-4 sm:grid-cols-4">
              <div className="flex flex-col gap-3">
                <p className="font-medium">Hujjat raqami:</p>
                <Input
                  type="text"
                  value={data.docNum || "-"}
                  style={{ color: "black" }}
                  className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                  disabled
                />
              </div>
              <div className="flex flex-col gap-3">
                <p className="font-medium">Ta'minotchi:</p>
                <Input
                  type="text"
                  value={data.cardName || "-"}
                  style={{ color: "black" }}
                  className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                  disabled
                />
              </div>
              <div className="flex flex-col gap-3">
                <p className="font-medium">Partiya raqami:</p>
                <Input
                  type="text"
                  value={data.U_PartyNumber || "-"}
                  style={{ color: "black" }}
                  className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                  disabled
                />
              </div>
              <div className="flex flex-col gap-3">
                <p className="font-medium">Transport turi:</p>
                <Input
                  type="text"
                  value={data.U_typeOfTransport || "-"}
                  style={{ color: "black" }}
                  className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                  disabled
                />
              </div>
              <div className="flex flex-col gap-3">
                <p className="font-medium">Transport raqami:</p>
                <Input
                  type="text"
                  value={data.U_NumberOfTransport || "-"}
                  style={{ color: "black" }}
                  className="flex h-10 w-full items-center justify-center border-[1px] border-[#D0D0D0] active:border-[#D0D0D0]"
                  disabled
                />
              </div>
            </div>

            <Table
              columns={columns}
              dataSource={modalData}
              pagination={false}
              loading={loading}
              className="border-1 mt-4 w-full border-black sm:mt-12"
              scroll={{ x: "100%" }}
              rowKey={(record, index) => record.docEntry || index}
              onRow={(record) => ({
                onClick: () => handleRowClick(record),
                style: { cursor: "pointer" },
              })}
            />
          </div>
        </div>
      </Modal>

      {/* Items Modal */}
      <Modal
        title={
          <h1 className="font-nunito text-xl font-extrabold text-[#000000]">
            Transport № {selectedRowData?.u_TransportNumber || ""} - Mahsulotlar
          </h1>
        }
        open={isItemsModalVisible}
        onCancel={() => {
          setIsItemsModalVisible(false);
          setSelectedRowData(null);
          setItemsData([]);
        }}
        footer={null}
        closeIcon={<CloseOutlined />}
        width="70%"
        bodyStyle={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        <div className="w-full px-4 sm:px-5">
          <Table
            columns={itemsColumns}
            dataSource={itemsData}
            pagination={false}
            loading={itemsLoading}
            className="border-1 mt-4 w-full border-black"
            scroll={{ x: "100%" }}
            rowKey={(record, index) => record.lineId || index}
          />
        </div>
      </Modal>
    </>
  );
};

export default TransportModal;
